module.exports = __webpack_public_path__ + "static/media/Extruded tooth16.e3aa39ba.png";